export const MEMBER_ALL_SET = "MEMBER_ALL_SET";

export const MEMBER_SET = "MEMBER_SET";

export const MEMBER_GROUP_SET = "MEMBER_GROUP_SET";

export const MEMBER_FOLLOW_UPDATE = "MEMBER_FOLLOW_UPDATE";
export const MEMBER_RESET = "MEMBER_RESET";
export const MEMBER_ALL_PRE_LOADING_SET = "MEMBER_ALL_PRE_LOADING_SET";
